export interface TeamMember {
    id: string;
    created_at?: string;
    name: string;
    category: 'ceo' | 'guide';
    image: string;
    role_es: string;
    role_en: string;
    role_pt?: string;
    role_fr?: string;
    role_it?: string;
    role_de?: string;
    bio_es: string;
    bio_en: string;
    bio_pt?: string;
    bio_fr?: string;
    bio_it?: string;
    bio_de?: string;
    order_index: number;
    // Climbing specific fields for a raw, outdoor vibe
    specialty_es?: string;
    specialty_en?: string;
    favorite_route_es?: string;
    favorite_route_en?: string;
}

export const MOCK_TEAM: TeamMember[] = [
    {
        id: 'ceo-valentina',
        name: 'Valentina Muñoz',
        category: 'ceo',
        image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=600&h=600',
        role_es: 'CEO / Guía de Montaña ANGM',
        role_en: 'CEO / ANGM Mountain Guide',
        role_pt: 'CEO / Guia de Montanha ANGM',
        role_fr: 'CEO / Guide de Montagne ANGM',
        role_it: 'CEO / Guida Alpina ANGM',
        role_de: 'CEO / ANGM Bergführer',
        bio_es: 'Nacida en Aysén, Valentina cuenta con más de 12 años abriendo nuevas líneas de escalada en los macizos más exigentes de la región. Su pasión es guiar de forma segura y transmitir el respeto absoluto por el entorno salvaje.',
        bio_en: 'Born in Aysén, Valentina has spent over 12 years opening new climbing routes across the region\'s most demanding massifs. Her passion is guiding safely while instilling a deep respect for the wild environment.',
        bio_pt: 'Nascida em Aysén, Valentina tem mais de 12 anos abrindo novas vias de escalada nos maciços mais exigentes da região. Sua paixão é guiar com segurança e transmitir respeito pelo ambiente selvagem.',
        bio_fr: 'Née en Aysén, Valentina a ouvert de nombreuses voies d\'escalade depuis plus de 12 ans dans les massifs de la région. Sa passion es de guider en toute sécurité tout en transmettant un profond respect pour la nature sauvage.',
        bio_it: 'Nata ad Aysén, Valentina ha oltre 12 anni di esperienza nell\'apertura di nuove vie di arrampicata nei massicci della regione. La sua passione è guidare in sicurezza trasmettendo il massimo rispetto per la natura.',
        bio_de: 'Valentina wurde in Aysén geboren und erschließt seit über 12 Jahren neue Kletterrouten in den anspruchsvollsten Massiven der Region. Ihre Leidenschaft ist das sichere Führen und die Vermittlung von Respekt vor der Wildnis.',
        specialty_es: 'Escalada tradicional en fisuras y Big Wall',
        specialty_en: 'Trad crack climbing and Big Wall',
        favorite_route_es: 'Pared Norte de Cerro Castillo (Vía del Viento)',
        favorite_route_en: 'Cerro Castillo North Face (Wind Route)',
        order_index: 1
    },
    {
        id: 'ceo-camilo',
        name: 'Camilo Barra',
        category: 'ceo',
        image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=600&h=600',
        role_es: 'CEO / Director de Logística & Seguridad',
        role_en: 'CEO / Logistics & Safety Director',
        role_pt: 'CEO / Diretor de Logística e Segurança',
        role_fr: 'CEO / Directeur de la Logistique & Sécurité',
        role_it: 'CEO / Direttore Logistica e Sicurezza',
        role_de: 'CEO / Leiter Logistik & Sicherheit',
        bio_es: 'Especialista en planificación técnica y gestión del riesgo. Camilo coordina las comunicaciones satelitales en tiempo real y la logística de cada expedición, asegurando que el equipo cuente con el respaldo de seguridad más riguroso en terreno.',
        bio_en: 'Specialist in technical planning and risk management. Camilo coordinates real-time satellite communications and expedition logistics, ensuring every team has the most rigorous safety support in the field.',
        bio_pt: 'Especialista em planejamento técnico e gestão de riscos. Camilo coordena comunicações via satélite e a logística de cada expedição, garantindo que a equipe tenha o suporte de segurança mais rigoroso.',
        bio_fr: 'Spécialiste de la planification technique et de la gestion des risques. Camilo coordonne les communications par satellite et la logistique, garantissant un soutien de sécurité rigoureux sur le terrain.',
        bio_it: 'Specialista in pianificazione tecnica e gestione del riesgo. Camilo coordina le comunicazioni satellitari e la logistica di ogni spedizione, garantendo il supporto di sicurezza più rigoroso.',
        bio_de: 'Spezialist für technische Planung und Risikomanagement. Camilo koordiniert die Satellitenkommunikation und Logistik jeder Expedition, um die strengsten Sicherheitsstandards im Gelände zu garantieren.',
        specialty_es: 'Planificación de seguridad y rescate en áreas remotas',
        specialty_en: 'Safety planning and remote area rescue',
        favorite_route_es: 'Travesía Campo de Hielo Sur',
        favorite_route_en: 'Southern Ice Field Traverse',
        order_index: 2
    },
    {
        id: 'guide-sofia',
        name: 'Sofía Guerrero',
        category: 'guide',
        image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=600&h=600',
        role_es: 'Guía de Escalada / Certificación WFR',
        role_en: 'Climbing Guide / WFR Certified',
        role_pt: 'Guia de Escalada / Certificação WFR',
        role_fr: 'Guide d\'Escalade / Certifiée WFR',
        role_it: 'Guida di Arrampicata / Certificata WFR',
        role_de: 'Kletterführerin / WFR-Zertifiziert',
        bio_es: 'Instructora experimentada con un enfoque especial en la escalada en roca de fisura. Sofía combina su destreza técnica con su certificación en medicina de áreas remotas (WFR) para guiar de forma segura e inspiradora.',
        bio_en: 'Experienced instructor with a special focus on crack climbing. Sofia combines her technical prowess with Wilderness First Responder (WFR) training to guide and inspire climbers safely.',
        bio_pt: 'Instrutora experiente com foco em escalada de fendas. Sofia combina destreza técnica com certificação WFR (Wilderness First Responder) para guiar de forma segura e inspiradora.',
        bio_fr: 'Instructrice expérimentée spécialisée dans l\'escalade de fissures. Sofia allie ses compétences techniques à sa formation WFR (Wilderness First Responder) pour guider et inspirer en toute sécurité.',
        bio_it: 'Istruttrice esperta specializzata in arrampicata in fessura. Sofia unisce le sue capacità tecniche alla certificazione Wilderness First Responder (WFR) per guidare in sicurezza e ispirare.',
        bio_de: 'Erfahrene Kletterlehrerin mit Schwerpunkt Rissklettern. Sofia verbindet ihr technisches Können mit ihrer WFR-Ausbildung (Wilderness First Responder), um Kletterer sicher zu führen.',
        specialty_es: 'Escalada clásica, rescate vertical y pedagogía de montaña',
        specialty_en: 'Trad climbing, vertical rescue, and mountain instruction',
        favorite_route_es: 'Aguja Guillaumet (Vía Amy)',
        favorite_route_en: 'Aguja Guillaumet (Amy Route)',
        order_index: 3
    },
    {
        id: 'guide-lucas',
        name: 'Lucas Silva',
        category: 'guide',
        image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=600&h=600',
        role_es: 'Guía de Trekking / Especialista en Geología Local',
        role_en: 'Trekking Guide / Local Geology Specialist',
        role_pt: 'Guia de Trekking / Especialista em Geologia Local',
        role_fr: 'Guide de Trekking / Spécialiste en Géologie Locale',
        role_it: 'Guida Trekking / Specialista in Geologia Locale',
        role_de: 'Trekkingführer / Spezialist für Lokale Geologie',
        bio_es: 'Apasionado de la flora, fauna e historia geológica de Aysén. Lucas convierte cada caminata en un viaje de descubrimiento científico e histórico bajo las sombras de las torres de Cerro Castillo.',
        bio_en: 'Passionate about Aysén\'s flora, fauna, and geological history. Lucas turns every trek into a journey of scientific and historical discovery under the shadow of Cerro Castillo\'s peaks.',
        bio_pt: 'Apaixonado pela flora, fauna e história geológica de Aysén. Lucas transforma cada caminhada em uma jornada de descoberta sob as torres de Cerro Castillo.',
        bio_fr: 'Passionné par la flore, la faune et l\'histoire géologique d\'Aysén. Lucas transforme chaque randonnée en un voyage de découverte scientifique sous les sommets de Cerro Castillo.',
        bio_it: 'Appassionato di flora, fauna e storia geologica di Aysén. Lucas trasforma ogni escursione in un viaggio di scoperta sotto l\'ombra del Cerro Castillo.',
        bio_de: 'Begeistert von der Flora, Fauna und Geologie von Aysén. Lucas macht jede Wanderung zu einer Entdeckungsreise im Schatten der Türme des Cerro Castillo.',
        specialty_es: 'Trekking de exploración, glaciología e historia natural',
        specialty_en: 'Exploratory trekking, glaciology, and natural history',
        favorite_route_es: 'Travesía Las Horquetas y glaciar del Turbio',
        favorite_route_en: 'Las Horquetas Traverse and Turbio glacier',
        order_index: 4
    }
];
